import {createContext, useContext} from 'react'

/** Surface the menu rows sit on — mirrors `TopNav`'s `color` vocabulary. */
export type MenuColor = 'light' | 'dark'

/**
 * Surface tone inherited by menu/sidebar rows — `dark` means "I'm on the deep
 * teal brand rail (`primary-contrast`)", so rows render white content instead of
 * `text-text-primary`. `Sidebar color="dark"` (or a bare `MenuColorProvider`)
 * sets it once; `MenuItem`, `CollapsibleMenuItem`, and `MenuHeader` read it,
 * exactly like `dense` / `collapsed`.
 *
 * Defaults to `light`, so nothing changes unless a provider wraps the rows. Note
 * that `CollapsibleMenuItem`'s mini-rail flyout resets this to `light` — the
 * `Popover` inside it is a white surface, not the rail.
 */
export const MenuColorContext = createContext<MenuColor>('light')

/** Provide a surface tone to all descendant menu items. */
export const MenuColorProvider = MenuColorContext.Provider

/** Read the inherited surface tone (default `light`). */
export function useMenuColor(): MenuColor {
  return useContext(MenuColorContext)
}
